export const allowClickHandlerList = ['discard-import', 'cancel'];
